import Dropdown from '@service-victoria/component-library/components/Dropdown';
import Input from '@service-victoria/component-library/components/Input';
import Text from '@service-victoria/component-library/components/Text';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import React from 'react';
import { constants, validatePreviousStep } from 'utils';
import * as Styled from '../styled';
import { Lookup } from './Lookup';
import VoucherType from './VoucherType';

export type ComponentProps = StepComponent<Pick<Interfaces.Common.FormValues, 'abn'>>;

const ABN: React.FC<ComponentProps> = ({ context }) => {
  React.useEffect(() => {
    validatePreviousStep('details', context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Styled.Wrapper>
      <Text.Heading.H1 fontWeight={600}>Business information</Text.Heading.H1>
      <Styled.Spacer24 />
      <VoucherType />
      <Styled.Spacer48 />
      <Text.Heading.H3 fontWeight={600}>Verify your ABN</Text.Heading.H3>
      <Styled.Spacer16 />
      <Lookup fieldName='abn' label='ABN' />
      <Styled.Spacer16 />
      <Input
        label='Business name (if different from entity name)'
        name='abn.optionalBusinessName'
      />
      <Styled.Spacer48 />
      <Text.Heading.H3 fontWeight={600}>Address</Text.Heading.H3>
      <Text.Body>Enter where the business using the voucher is located.</Text.Body>
      <Text.Body>City of Melbourne locations aren’t eligible for a voucher.</Text.Body>
      <Styled.Spacer16 />
      <Styled.InputContainer>
        <Input
          label='Street address'
          name='abn.address.fullAddress'
          hint='Include unit or apartment number, street number and street name.'
        />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input label='Suburb/Town' name='abn.address.suburb' />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Dropdown
          name='abn.address.state'
          label='State/Territory'
          disabled={true}
          options={constants.stateOptions}
        />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input label='Postcode' name='abn.address.postCode' />
      </Styled.InputContainer>
    </Styled.Wrapper>
  );
};

export default ABN;
